// extracted by mini-css-extract-plugin
export default {"cards":"newJob_cards__pzXZZ","title":"newJob_title__k2TCe"};